import { useTranslation } from 'react-i18next';
import './Footer.scss';
import { useState, useEffect } from 'react';

const gT = (t, key) => t(`footer${key}`);

export default function Footer() {
  const { t } = useTranslation('app');
  const [currentYear, setCurrentYear] = useState(2000);

  useEffect(() => {
    const currentDate = new Date();
    setCurrentYear(currentDate.getUTCFullYear());
  }, []);

  return (
    <div className="app-footer-wrapper">
      <div className="footer-content">
        <a
          className="link"
          href="/about"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kontakta oss
        </a>
        <p className="trademark">
          &copy; {currentYear} {gT(t, '.trademark.0')}
        </p>
        <p
          className="trademark"
          style={{ textAlign: 'right', maxWidth: '400px', marginLeft: 'auto' }}
        >
          {gT(t, '.trademark.1')}
        </p>
      </div>
    </div>
  );
}
